import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "container overflow-hidden tw color-unset lineheight-unset expense-print-root"
};
const _hoisted_2 = {
  key: 2,
  class: "flex overflow-hidden bg-white expense-print-flex"
};
const _hoisted_3 = {
  class: "flex flex-col flex-shrink-0 py-2 pl-4 pr-6 space-y-2 w-2/12 sidebar-height no-print mt-2 overflow-y-auto"
};
const _hoisted_4 = {
  class: "flex flex-col pb-28 px-8 w-10/12 print:w-full main-content-height bg-white shadow-sm"
};
const _hoisted_5 = {
  class: "matter-header"
};
const _hoisted_6 = {
  "data-cy": "expense-list-client-header"
};
const _hoisted_7 = {
  "data-cy": "expense-list-matter-header"
};
const _hoisted_8 = {
  class: "matter-header"
};
const _hoisted_9 = {
  class: "matter-header"
};
const _hoisted_10 = {
  class: "flex-col w-full no-print"
};
const _hoisted_11 = {
  class: "flex justify-between px-2 py-2 no-print"
};
const _hoisted_12 = {
  class: "relative my-1 mr-2 w-1/5"
};
const _hoisted_13 = {
  key: 0,
  class: "flex justify-end px-8 py-2"
};
const _hoisted_14 = {
  class: "px-2"
};
const _hoisted_15 = {
  key: 2,
  class: "table-container"
};
import RouteService from '@/services/RouteService';
import LlPagination from '@/components/LlPagination.vue';
import Loader from '@/components/Loader.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import ExpenseFilter from './ExpenseFilter.vue';
import ExpenseEdit from '@/modules/expenses/ExpenseEdit.vue';
import ExpenseListTable from './ExpenseListTable.vue';
import MultipleAttachmentPreview from '../../components/MultipleAttachmentPreview.vue';
import { attachmentsToFileSelector } from '@/utils/attachmentsToFileSelector.js';
import LlSearch from '@/components/LlSearch.vue';
import { useTrustAccountingStore } from '@/services/trustAccountingStore.js';
import ClientMatterSearch from '../../components/ClientMatterSearch.vue';
import { reactive, onMounted, onBeforeUnmount, watch, computed } from 'vue';
import DateRangeSelect from '@/components/DateRangeSelect.vue';
import LlDatePicker from '@/components/LlDatePicker.vue';
import MatterInvolvingFilter from '@/components/MatterInvolvingFilter.vue';
import SnackbarComponent from '@/components/SnackbarComponent.vue';
import { formatCurrency } from '@/services/utils';
import { useExportUtilities } from '@/composables/useExportUtilities';
import LlWarningBanner from '@/components/LlWarningBanner.vue';
export default {
  __name: 'ExpenseLists',
  props: {
    stateParams: {
      type: Object,
      required: true
    },
    singleRequest: {
      type: Object,
      required: true
    },
    state: {
      type: Object,
      required: true
    },
    matterFilterService: {
      type: Object,
      required: true
    },
    leanLawApi: {
      type: Object,
      required: true
    },
    alerts: {
      type: Object,
      required: true
    },
    userService: {
      type: Object,
      required: true
    },
    tracking: {
      type: Object,
      required: true
    },
    rootScope: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    const trustAccountingStore = useTrustAccountingStore();
    const expenseState = reactive({
      assignedExpenses: [],
      method: 'Expense Page',
      pagination: {},
      total: 0,
      expenses: [],
      me: {},
      loading: true,
      loadingExpensesList: true,
      showType: false,
      unassigned: [],
      showEditModal: false,
      options: {},
      request: {
        range: {},
        currentPage: 1,
        orderby: 'date',
        order: 'asc',
        limit: 25,
        client: {},
        matter: {},
        scopeAccount: undefined,
        primary: false,
        originating: false,
        reviewer: false,
        billedState: {},
        search: ''
      },
      selectedExpense: undefined,
      editStateParams: {},
      dialogInstance: 0,
      showAttachmentPreview: false,
      vendorsList: [],
      loadEntriesTimeout: null
    });
    const totalPages = computed(() => Math.ceil(expenseState.pagination?.total / expenseState.request.limit || 0));
    const cmQuery = computed(() => {
      return {
        originating: expenseState.request.originating || false,
        primary: expenseState.request.primary || false,
        reviewer: expenseState.request.reviewer || false,
        involved: expenseState.request.scopeAccount?.id ? true : false,
        scopeAccount: expenseState.request.scopeAccount?.id
      };
    });
    const routeService = new RouteService(props);
    const {
      exportExpenses
    } = useExportUtilities();
    onMounted(async () => {
      expenseState.loading = true;
      expenseState.me = await props.userService.getMe();
      expenseState.showType = expenseState.me.company.settings.expenses?.sync || false;
      expenseState.assigned = props.stateParams?.assigned;
      await getUnassignedExpenses();
      expenseState.vendorsList = await trustAccountingStore.accountingListVendors();
      await props.matterFilterService.loaded;
      setScopeBasedOnState();
      expenseState.options = props.matterFilterService.options;

      // Pre-fill client/matter filters when navigated from another page (e.g. settlement wizard)
      if (props.stateParams?.matterId) {
        expenseState.request.matter = {
          id: props.stateParams.matterId,
          label: props.stateParams.matterName || ''
        };
      }
      if (props.stateParams?.clientId) {
        expenseState.request.client = {
          id: props.stateParams.clientId,
          label: props.stateParams.clientName || ''
        };
      }
      // Clear date range to show all-time when arriving with pre-set filters
      if (props.stateParams?.matterId || props.stateParams?.clientId) {
        expenseState.request.range = {};
      }
      expenseState.loading = false;
    });
    const openEditDialog = stateParams => {
      expenseState.editStateParams = {
        ...stateParams
      };
      expenseState.dialogInstance += 1;
      expenseState.showEditModal = true;
    };
    const openNewExpense = () => {
      expenseState.selectedExpense = undefined;
      expenseState.selectedMatter = undefined;
      openEditDialog({
        ...props.stateParams,
        expenseId: null
      });
    };
    const stopStateChangeListener = props.rootScope.$on('$stateChangeSuccess', (event, toState, toParams) => {
      if (toParams?.header) openNewExpense();
    });
    onBeforeUnmount(() => stopStateChangeListener?.());

    // Deep-link: open a specific expense on load when ?expenseId=xxx is present in the URL.
    // Mirrors the Fixed Fees chargeId/panel pattern. The immediate flag handles the initial
    // navigation; re-watches handle in-page pushState updates (notify:false navigations).
    watch(() => props.stateParams?.expenseId, expenseId => {
      if (expenseId) {
        expenseState.selectedExpense = {
          id: expenseId
        };
        openEditDialog(props.stateParams);
      }
    }, {
      immediate: true
    });

    // After the deep-link watch on purpose: 'expenses.list.new' inherits expenseId from
    // 'expenses.list', so both params can be set at once. An explicit "New Expense" click
    // beats an expenseId that only rode along from the URL we were already on.
    if (props.stateParams?.header) openNewExpense();
    const setScopeBasedOnState = () => {
      const {
        scopeAccount,
        primary,
        originating,
        reviewer
      } = props.matterFilterService.state;
      expenseState.request.scopeAccount = scopeAccount;
      expenseState.request.primary = primary;
      expenseState.request.originating = originating;
      expenseState.request.reviewer = reviewer;
      const scopes = [];
      if (primary) scopes.push('primary');
      if (reviewer) scopes.push('reviewer');
      if (originating) scopes.push('originating');
      if (scopes.length) {
        expenseState.request.scope = scopes.join(',');
      } else if (scopeAccount?.id) {
        expenseState.request.scope = 'involved';
      } else {
        expenseState.request.scope = 'all';
      }
    };
    watch(() => expenseState.request.search, () => {
      clearTimeout(expenseState.loadEntriesTimeout);
      expenseState.loadEntriesTimeout = setTimeout(() => {
        loadExpenses();
      }, 1000);
    });
    const makeRequestObject = request => {
      let {
        startDate,
        endDate
      } = request.range || {};
      return {
        ...request,
        offset: (request.currentPage - 1) * request.limit || 0,
        matterId: request.matter?.id,
        clientId: request.client?.id,
        scopeAccount: request.scopeAccount?.id,
        startDate: startDate ? new Date(startDate).toNetworkDate() : undefined,
        endDate: endDate ? new Date(endDate).toNetworkDate() : undefined
      };
    };
    const loadExpenses = async () => {
      try {
        const request = JSON.parse(JSON.stringify(expenseState.request));
        expenseState.loadingExpensesList = true;
        expenseState.assignedExpenses = await props.singleRequest.apiCall('expenses').listExpenses(makeRequestObject(request));
        expenseState.expenses = expenseState.assignedExpenses.expenses.map(e => ({
          id: e.id,
          accounting: e.accounting,
          date: e.date,
          type: e.expenseType,
          user: e.account?.initials || e.account?.name,
          client: e.client?.label,
          matterDetails: e.matter,
          matter: e.matter?.label,
          description: e.description,
          code: e.code?.id,
          amount: e.amount,
          billed: e.billed,
          attachments: e.attachments,
          customFlag: e.customFlag,
          vendor: e.vendor,
          checkNumber: e.checkNumber
        })) || [];
        expenseState.pagination = expenseState.assignedExpenses.pagination || {};
        expenseState.total = expenseState.assignedExpenses.total || 0;
      } catch (err) {
        props.alerts.error(err);
      } finally {
        expenseState.loadingExpensesList = false;
      }
    };
    const getUnassignedExpenses = () => {
      try {
        if (!expenseState.assignedExpenses) return;
        if (expenseState.me.permissions.expenses.assign) {
          props.leanLawApi.listExpenses({
            assigned: false
          }).then(lists => {
            expenseState.unassigned = lists.expenses || [];
          });
        }
      } catch (err) {
        props.alerts.error(err);
      }
    };
    const edit = expense => {
      expenseState.selectedExpense = JSON.parse(JSON.stringify(expense));
      expenseState.selectedExpense.matter = expense.matterDetails;
      openEditDialog(props.stateParams);
    };
    const viewAttachments = expense => {
      if (!expense.attachments?.length) return;
      expenseState.fileSelector = attachmentsToFileSelector(expense.attachments);
      expenseState.showAttachmentPreview = true;
    };
    const importExpenses = () => {
      // Check if the user has the vueEquitrac feature flag enabled
      if (expenseState.me.features?.vueEquitrac) {
        routeService.go('expenses.equitrac-import');
      } else {
        routeService.go('expenses.import');
      }
    };
    const print = () => {
      window.print();
    };
    const exportCSV = async () => {
      expenseState.loadingExportCSV = true;
      try {
        const request = JSON.parse(JSON.stringify(expenseState.request));
        request.limit = null;
        request.offset = null;
        const assignedExpenses = await props.leanLawApi.listExpenses(makeRequestObject(request));

        // Validate we have data to export
        if (!assignedExpenses?.expenses?.length) {
          props.alerts.info('No expenses found to export');
          return;
        }
        const {
          settings
        } = expenseState.me.company;
        const customFlag = settings.labels && settings.labels.customFlag;
        const showLedes = settings.codes && settings.codes.ledes;
        const exportOptions = {
          includeExpenseType: expenseState.showType,
          includeUser: true,
          includeExpenseCode: showLedes,
          includeVendor: expenseState.me.features?.importcsv,
          includeCheckNumber: settings.expenses?.includeCheckNumberInDescription,
          terms: expenseState.me.terms,
          showType: expenseState.showType,
          customFlag: customFlag
        };
        await exportExpenses(assignedExpenses.expenses, formatCurrency, exportOptions, expenseState.request);

        // Show success message
        props.alerts.success(`Successfully exported ${assignedExpenses.expenses.length} expenses`);
      } catch (error) {
        console.error('Export failed:', error);
        props.alerts.error('Failed to export expenses. Please try again.');
      } finally {
        expenseState.loadingExportCSV = false;
      }
    };
    const newExpense = () => {
      const matterId = expenseState.request?.matter?.id;
      expenseState.selectedMatter = matterId;
      expenseState.selectedExpense = undefined;
      openEditDialog({
        ...props.stateParams,
        expenseId: null
      });
    };
    const assignExpense = () => {
      routeService.go('expenses.unassigned');
    };
    const sort = (orderby, order) => {
      expenseState.request.orderby = orderby;
      expenseState.request.order = order;
      loadExpenses();
    };
    const expenseFilterChanged = filter => {
      expenseState.request.currentPage = 1;
      expenseState.request = Object.assign(expenseState.request, filter);
      loadExpenses();
    };
    const closeEditModal = reload => {
      expenseState.selectedExpense = undefined;
      if (reload) {
        loadExpenses();
      }
      expenseState.showEditModal = false;
    };
    const importCSV = () => {
      routeService.go('expenses.expense-import');
    };
    const dateRangeFilterChanged = dateSelect => {
      expenseState.request.range = dateSelect;
      loadExpenses();
    };
    const matterInvolvingChange = updatedForm => {
      // Update the local state with the form data from the MatterInvolvingFilter component
      expenseState.request = updatedForm;
      loadExpenses();
    };
    return (_ctx, _cache) => {
      const _component_v_dialog = _resolveComponent("v-dialog");
      const _component_v_icon = _resolveComponent("v-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(SnackbarComponent, {
        ref: "snackbar"
      }, null, 512), expenseState.showEditModal ? (_openBlock(), _createBlock(_component_v_dialog, {
        key: 0,
        modelValue: expenseState.showEditModal,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => expenseState.showEditModal = $event),
        width: "700"
      }, {
        default: _withCtx(() => [(_openBlock(), _createBlock(ExpenseEdit, {
          key: expenseState.dialogInstance,
          stateParams: expenseState.editStateParams,
          leanLawApi: __props.leanLawApi,
          alerts: __props.alerts,
          method: "Expense Page",
          state: __props.state,
          userService: __props.userService,
          selectedMatter: expenseState.selectedMatter,
          selectedExpense: expenseState.selectedExpense,
          tracking: __props.tracking,
          onFilter: closeEditModal
        }, null, 8, ["stateParams", "leanLawApi", "alerts", "state", "userService", "selectedMatter", "selectedExpense", "tracking"]))]),
        _: 1
      }, 8, ["modelValue"])) : _createCommentVNode("", true), expenseState.loading ? (_openBlock(), _createBlock(Loader, {
        key: 1,
        what: "Expenses",
        class: "mt-32 w-full"
      })) : (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(ClientMatterSearch, {
        me: expenseState.me,
        emitOnAnyChange: true,
        horizontal: true,
        cm: expenseState.request,
        "query-filter": cmQuery.value,
        onMatterChange: _cache[1] || (_cache[1] = $event => loadExpenses())
      }, null, 8, ["me", "cm", "query-filter"]), _createVNode(MatterInvolvingFilter, {
        lockAccountSelection: expenseState.options.lockAccountSelection,
        form: expenseState.request,
        horizontal: true,
        onMatterInvolvingChange: matterInvolvingChange
      }, null, 8, ["lockAccountSelection", "form"]), _createVNode(DateRangeSelect, {
        range: expenseState.request.range,
        "default-range": 'Time Period',
        onDateRangeFilter: dateRangeFilterChanged
      }, null, 8, ["range"]), _createVNode(ExpenseFilter, {
        userService: __props.userService,
        onFilter: expenseFilterChanged
      }, null, 8, ["userService"]), _withDirectives(_createVNode(LlSecondaryButton, {
        onBtnClick: _cache[2] || (_cache[2] = $event => importCSV()),
        class: "w-full my-2 mt-4"
      }, {
        default: _withCtx(() => [_createVNode(_component_v_icon, {
          class: "mx-2"
        }, {
          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode("mdi-tray-arrow-up", -1)]))]),
          _: 1
        }), _cache[11] || (_cache[11] = _createTextVNode(" Expense Import ", -1))]),
        _: 1
      }, 512), [[_vShow, expenseState.me.features?.importcsv && expenseState.me.features.expenseImport]]), _withDirectives(_createVNode(LlSecondaryButton, {
        onBtnClick: _cache[3] || (_cache[3] = $event => importExpenses()),
        class: "w-full"
      }, {
        default: _withCtx(() => [_createVNode(_component_v_icon, {
          class: "mx-2"
        }, {
          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode("mdi-tray-arrow-up", -1)]))]),
          _: 1
        }), _cache[13] || (_cache[13] = _createTextVNode(" Equitrac Import ", -1))]),
        _: 1
      }, 512), [[_vShow, expenseState.me.permissions?.expenses?.assign && expenseState.me.features.expenseImport]])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", null, [_withDirectives(_createElementVNode("div", _hoisted_5, [_createElementVNode("h2", _hoisted_6, _toDisplayString(expenseState.request?.client?.label), 1), _createElementVNode("h1", _hoisted_7, _toDisplayString(expenseState.request?.matter?.label), 1)], 512), [[_vShow, expenseState.request?.matter]]), _withDirectives(_createElementVNode("div", _hoisted_8, [_createElementVNode("h2", null, _toDisplayString(expenseState.request?.client?.label), 1)], 512), [[_vShow, expenseState.request?.client && !expenseState.request?.matter]]), _withDirectives(_createElementVNode("div", _hoisted_9, [...(_cache[14] || (_cache[14] = [_createElementVNode("h2", null, "All Clients", -1)]))], 512), [[_vShow, !expenseState.request.matter && !expenseState.request.client]])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createVNode(LlSearch, {
        modelValue: expenseState.request.search,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => expenseState.request.search = $event),
        label: "Search Expenses"
      }, null, 8, ["modelValue"])]), _createElementVNode("div", null, [_createVNode(LlSecondaryButton, {
        onBtnClick: _cache[5] || (_cache[5] = $event => exportCSV()),
        variant: "text",
        class: "mr-2",
        color: ""
      }, {
        default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode(" Export ", -1)]))]),
        _: 1
      }), _createVNode(LlSecondaryButton, {
        onBtnClick: _cache[6] || (_cache[6] = $event => print()),
        variant: "text",
        class: "mx-2",
        color: ""
      }, {
        default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode(" Print ", -1)]))]),
        _: 1
      }), _withDirectives(_createVNode(LlSecondaryButton, {
        onBtnClick: _cache[7] || (_cache[7] = $event => newExpense()),
        variant: "flat",
        "prepend-icon": "mdi-plus",
        color: "primary",
        "data-cy": "create-expense"
      }, {
        default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createTextVNode(" Create Expense ", -1)]))]),
        _: 1
      }, 512), [[_vShow, expenseState.me.permissions?.expenses?.create]])])])]), totalPages.value > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(LlPagination, {
        request: expenseState.request,
        totalPages: totalPages.value,
        total: expenseState.pagination.total,
        onLoadExpenses: loadExpenses
      }, null, 8, ["request", "totalPages", "total"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_14, [_createVNode(LlWarningBanner, {
        visible: !!expenseState.unassigned.length && !!expenseState.me.permissions?.expenses?.assign,
        "button-text": "Assign Expenses",
        onAction: assignExpense
      }, {
        default: _withCtx(() => [_cache[18] || (_cache[18] = _createTextVNode(" You have ", -1)), _createElementVNode("b", null, _toDisplayString(expenseState.unassigned.length) + " unassigned billable expense in QuickBooks.", 1)]),
        _: 1
      }, 8, ["visible"])]), _createVNode(_component_v_dialog, {
        modelValue: expenseState.showAttachmentPreview,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => expenseState.showAttachmentPreview = $event),
        width: "800"
      }, {
        default: _withCtx(() => [_createVNode(MultipleAttachmentPreview, {
          previewSource: expenseState.fileSelector,
          onCancel: _cache[8] || (_cache[8] = $event => expenseState.showAttachmentPreview = false),
          selectedFileIndex: 0
        }, null, 8, ["previewSource"])]),
        _: 1
      }, 8, ["modelValue"]), expenseState.loadingExpensesList ? (_openBlock(), _createBlock(Loader, {
        key: 1,
        what: "Expenses List",
        class: "mt-32 w-full"
      })) : (_openBlock(), _createElementBlock("div", _hoisted_15, [_createVNode(ExpenseListTable, {
        expenses: expenseState.expenses,
        total: expenseState.total,
        request: expenseState.request,
        showType: expenseState.showType,
        me: expenseState.me,
        vendorsList: expenseState.vendorsList,
        leanLawApi: __props.leanLawApi,
        userService: __props.userService,
        alerts: __props.alerts,
        onEditExpense: edit,
        onSort: sort,
        onViewAttachments: viewAttachments
      }, null, 8, ["expenses", "total", "request", "showType", "me", "vendorsList", "leanLawApi", "userService", "alerts"])]))])]))]);
    };
  }
};